// extracted by mini-css-extract-plugin
export var border = "index-module--border--7xsDO";
export var container = "index-module--container--klVKB";